module.exports = __webpack_public_path__ + "static/media/ic_movement.063450d7.png";